import { useMutation } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { FlaskConical } from 'lucide-react';
import { PLAN_TIERS } from '@maintenance-tracker/shared';
import { api } from '@/lib/utils';
import { useAuth } from '@/lib/auth';

const TIER_LABELS: Record<string, string> = {
  lite: 'Lite',
  starter: 'Starter',
  growth: 'Growth',
  pro: 'Pro',
};

export function DevPlanSwitcher() {
  const { refresh, usage } = useAuth();

  const { data: dev } = useQuery({
    queryKey: ['dev-context'],
    queryFn: () => api<{ dev: boolean }>('/api/v1/dev/context'),
    staleTime: 60_000,
  });

  const switchPlan = useMutation({
    mutationFn: (tier: string) =>
      api('/api/v1/e2e/set-plan-tier', {
        method: 'POST',
        body: JSON.stringify({ tier, end_trial: true }),
      }),
    onSuccess: () => refresh(),
  });

  if (!dev?.dev) return null;

  const currentTier = (usage as { tier?: string })?.tier ?? 'lite';

  return (
    <div className="mx-3 mb-3 rounded-xl border border-amber-500/30 bg-amber-500/10 p-3">
      <div className="mb-2 flex items-center gap-2 text-[12px] font-semibold text-amber-200">
        <FlaskConical className="h-3.5 w-3.5" />
        Dev: switch plan
      </div>
      <select
        value={currentTier}
        onChange={(e) => switchPlan.mutate(e.target.value)}
        disabled={switchPlan.isPending}
        className="w-full rounded-lg border border-white/10 bg-sidebar px-2 py-1.5 text-[13px] text-white"
      >
        {PLAN_TIERS.map((t) => (
          <option key={t} value={t}>
            {TIER_LABELS[t] ?? t}
          </option>
        ))}
      </select>
      <p className="mt-1.5 text-[11px] leading-snug text-sidebar-text">
        Local only — instantly test feature gates per tier.
      </p>
    </div>
  );
}
